import axios from 'axios'
import store from '../store/index'
import router from '../router/index'

const locationUrl = location.href.split('#')[0]
locationUrl = locationUrl.split('?')[0]
const baseUrl = locationUrl.replace('/shuduier/', '')
store.dispatch('SET_BASEURL', baseUrl)
axios.defaults.baseURL = store.state.baseurl + '/api/'

//axios.defaults.baseURL = 'http://192.168.1.110/api/'

//应用数据初始化
var initAppData = (url) => axios({
    url: 'init',
    params: {
        url: url
    }
})

//获取微信jssdk配置验证
var getWechatSet = (url) => axios({
    url: 'weixin/wxjssdk',
    params: {
        url: url
    }
})

//请求发送之前显示loading
axios.interceptors.request.use(function(config) {
        store.dispatch('UPDATE_LOADING_STATUS', { isLoading: true })
        return config;
    }, function(error) {
        return Promise.reject(error);
    })
    //请求响应成功后停止显示loading
axios.interceptors.response.use(function(response) {
    store.dispatch('UPDATE_LOADING_STATUS', { isLoading: false })
    if ((!response.data.status) && response.data.errorKey === 'unavailable') {
        router.replace({ path: '/systemMaintenance' })
    }
    return response;
}, function(error) {
    return Promise.reject(error);
})

//获取首页数据
var getIndex = () => axios('');

//获取article详情
var getArticle = (article_id) => axios('article/' + article_id)

//提交缺书登记信息
var subLackBook = (book_title, book_isbn) => axios({
    url: 'user/checkin',
    params: {
        title: book_title,
        isbn: book_isbn
    }
})

//获取用户缺书登记列表
var getUserLackBookList = (page, rows) => axios({
    url: 'user/checkinList',
    params: {
        page: page,
        rows: rows
    }
})

//获取搜索结果
var getSearchResult = (search) => axios({
    url: 'book/search',
    params: {
        key: search.key,
        sort: search.sort,
        way: search.way,
        page: search.page,
        rows: search.rows
    }
})

//获取搜索热词
var getSearchHot = () => axios('book/searchHotKey')

//获取分类列表
var getCatagrayList = () => axios({
    url: 'category/categoryitemList',
    params: {
        child: 'child'
    }
})

//获取套装图书信息
var getSuitBookList = (book_id) => axios('book/booksuitList/' + book_id)

//根据ISBN检索
var getIsbnResult = (isbn) => axios({
    url: 'book/findIsbn',
    params: {
        isbn: isbn
    }
})

//获取分类图书列表
var getCatagrayBookList = (params) => axios({
    url: 'book/categoryBookList',
    params: {
        clc_code: params.clc_code,
        page: params.page,
        rows: params.rows
    }
})

//获取专题图书列表
var getSubjectBookList = (params) => axios({
    url: 'book/subjectBookList/' + params.subject_id,
    params: {
        page: params.page,
        rows: params.rows
    }
})

//获取图书详情数据
var getBook = (params) => axios({
    url: 'book/' + params.book_id
})

//获取我的地址列表
var getUserAddress = () => axios({
    url: 'user/myAddress'
})

//图书借阅
var borrowBook = (params) => axios({
    url: 'borrow/borrowBook',
    params: params
})

//错误的读者卡密码重置
var resetCardPassword = (passWord) => axios({
    url: 'user/resetCardpwd',
    method: 'post',
    params: {
        cardpwd: passWord
    }
})

//获取下单页信息
var getBookOrder = (params) => axios({
    url: 'borrow/borrowDetail/' + params.book_id,
    params: {
        address_id: params.address_id,
        booksuit_id: params.booksuit_id
    }
})

//获取积分规则数据
var getpointrule = () => axios('mall/pointruleList')

//获取奖品详情数据
var getPrize = (id) => axios('mall/prize/' + id)

//获取我的奖品兑换列表
var getexchange = () => axios('mall/myExchange')

//获取兑奖下单信息
var getCashPrizeInfo = (id) => axios({
    url: 'mall/prizeOrder/' + id
})

//获取兑奖下单地址信息
var getCashPrizeAddress = (id, address_id) => axios({
    url: 'mall/prizeOrder/' + id,
    params: {
        address_id: address_id
    }
})

//获取我的书架数据
var getMyBookcase = (sort, page, rows) => axios({
    url: 'user/myBookshelf',
    method: 'get',
    params: {
        sort: sort,
        page: page,
        rows: rows
    }
})

//获取物流信息
var getExpressTrace = (expressorder_id, user_id) => axios({
    url: 'user/expressTrace/' + expressorder_id
})

//获取积分明细数据
var getPointflow = () => axios('mall/pointflow')

//获取首页数据
var getPointIndex = () => axios('mall')

//确认兑换
var sureExchange = (id, address_id) => axios({
    url: 'mall/exchange/' + id,
    method: 'post',
    params: {
        address_id: address_id
    }
})

//订单详情
var orderDetail = (borrowno) => axios({
    url: 'borrow/' + borrowno
})

//获得任务中心数据
var getTaskCenter = (user_id) => axios('mall/pointTask')

//获得读者帮助列表
var getmenuItemList = () => axios('help')

//续借
var renewBorrow = (borrow_id) => axios({
    url: 'borrow/renewBorrow/' + borrow_id
})

//取消订单
var cancelBorrowOrder = (borrow_id) => axios({
    url: 'borrow/cancelBorrowBook',
    method: 'post',
    params: {
        borrow_id: borrow_id
    }
})

//确认归还
var returnBorrow = (borrow_id) => axios({
    url: 'borrow/returnBorrow/' + borrow_id
})


//今日签到
var signToday = () => axios({
    url: 'mall/signin',
    method: 'post'
})

//获取用户借阅列表
var getMyBorrow = (status, page, rows) => axios({
    url: 'borrow/borrowList',
    method: 'get',
    params: {
        status: status,
        page: page,
        rows: rows
    }
})

//删除我的书架图书
var deleteBookCase = (bs_id) => axios({
    url: 'user/deleteBookshelf/' + bs_id,
    method: 'post'
})

//登陆
var loginIn = (name, password) => axios({
    url: 'user/loginIn',
    method: 'post',
    params: {
        name: name,
        password: password
    }
})

//退出登陆
var loginOut = () => axios({
    url: 'user/loginOut'
})

//发送手机验证码
var sendPhoneCode = (phone, type, isSessionPhone) => axios({
    url: 'user/phoneCode',
    method: 'get',
    params: {
        phone: phone,
        type: type,
        isSessionPhone: isSessionPhone
    }
})

//验证手机验证码
var validatePhoneCode = (code) => axios({
    url: 'user/validatePhoneCode',
    method: 'get',
    params: {
        code: code
    }
})

//注册设置密码
var signUpSetPassword = (password) => axios({
    url: 'user/registerUser',
    method: 'post',
    params: {
        password: password
    }
})

//上传头像
var uploadProfile = (form) => axios({
    url: 'user/uploadAvatarImg',
    method: 'post',
    data: form,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
})

//修改用户个人信息
var editUserInfo = (nickname, gender) => axios({
    url: 'user/editUserInfo',
    method: 'post',
    params: {
        nickname: nickname,
        gender: gender
    }
})

//更换手机号
var changePhone = (code, phone) => axios({
    url: 'user/changePhone',
    method: 'post',
    params: {
        code: code,
        phone: phone
    }
})

//机构列表
var orgList = () => axios('org/orgList')

//绑定读者卡
var bindingCard = (org_id, cardno, cardpwd) => axios({
    url: 'user/bindingCard',
    method: 'post',
    params: {
        org_id: org_id,
        cardno: cardno,
        cardpwd: cardpwd
    }
})

//用户消息
var messageList = (page, rows) => axios({
    url: 'user/messageList',
    params: {
        page: page,
        rows: rows
    }
})

//是否绑定读者卡
var isBinding = (user_id) => axios({
    url: 'user/isBinding'
})

//添加地址
var addAddress = (name, phone, address, province_code, city_code, area_code, is_default) => axios({
    url: 'user/editAddress',
    params: {
        name: name,
        phone: phone,
        address: address,
        province_code: province_code,
        city_code: city_code,
        area_code: area_code,
        is_default: is_default
    }
})

//修改地址
var editAddress = (address_id, name, phone, address, province_code, city_code, area_code, is_default) => axios({
    url: 'user/editAddress/' + address_id,
    params: {
        name: name,
        phone: phone,
        address: address,
        province_code: province_code,
        city_code: city_code,
        area_code: area_code,
        is_default: is_default
    }
})


//删除地址
var deleteAddress = (address_id) => axios({
    url: 'user/deleteAddress/' + address_id
})

//解绑读者卡
var unbunding = () => axios({
    url: 'user/unbunding'
})

//设为默认地址
var setDefAddress = (address_id) => axios({
    url: 'user/setDefAddress/' + address_id
})

//获取地址的详细信息
var addressInfo = (address_id) => axios({
    url: 'user/addressInfo/' + address_id
})

//重置密码
var resetPassword = (password) => axios({
    url: 'user/resetPassword',
    method: 'post',
    params: {
        password: password
    }
})

//修改密码
var changePassword = (oldPassword, password) => axios({
    url: 'user/changePassword',
    method: 'post',
    params: {
        password: password,
        oldPassword: oldPassword
    }
})

//加入书架
var addBookshelf = (book_id, user_id) => axios({
    url: 'user/addBookshelf/' + book_id
})

//获取特殊专题图书列表
var specialBookList = (code) => axios({
    url: 'book/specialBookList/' + code
})

//获取在线办证首页信息
var getOnlinecard = () => axios('ecard')

//开始在线办证
var beginOnlinecard = (org_id) => axios({
    url: 'ecard/subOrg',
    method: 'get',
    params: {
        org_id: org_id
    }
})

//获得在线办证须知
var getonlinecardRule = (user_id) => axios('ecard/rule' + '?user_id=' + user_id)

//提交在线办证表单信息
var onlinecardInfo = (name, gender, idno, mobile, address, job, education) => axios({
    url: 'ecard/subInfo',
    method: 'get',
    params: {
        name: name,
        gender: gender,
        idno: idno,
        mobile: mobile,
        address: address,
        job: job,
        education: education
    }
})

//上传头像
var UpLoadCardfile = (form) => axios({
    url: 'ecard/subIdimg',
    method: 'post',
    data: form,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
})

//微信支付
var wxpay = (userid) => axios({
    url: 'weixin/wxpay',
    method: 'post',
    params: {
        userid: userid
    }
})
//在线办证押金
var getEcardFee = (userid) => axios({
    url: 'v4/ecard/getEcardFee',
    params: {
        userid: userid
    }
})

//在线办证订单支付
var payOk = (userid) => axios({
    url: 'ecard/payOk',
    params: {
        userid: userid
    }
})

//确认收货
var confirmSignup = (borrow_id) => axios({
    url: 'borrow/confirmSignup',
    method: 'post',
    params: {
        borrow_id: borrow_id
    }
})

//引导页
var tipIndex = () => axios('tipIndex')

//获得在线办证单号、用户信息
var getOrderDetail = () => axios('ecard/ecardorderDetail')

//
var hasEcardOrgList = () => axios('org/hasEcardOrgList')

//图书详情页分享加积分
var sharePoint = () => axios('mall/addPointByShare')

export {
    initAppData,
    getonlinecardRule,
    onlinecardInfo,
    subLackBook,
    getUserLackBookList,
    borrowBook,
    resetCardPassword,
    getIndex,
    getArticle,
    getSearchHot,
    getSearchResult,
    getSuitBookList,
    getIsbnResult,
    getCatagrayList,
    getCatagrayBookList,
    getSubjectBookList,
    getBook,
    getUserAddress,
    getBookOrder,
    getpointrule,
    getPrize,
    getTaskCenter,
    loginIn,
    loginOut,
    sendPhoneCode,
    validatePhoneCode,
    signUpSetPassword,
    getexchange,
    getWechatSet,
    getCashPrizeInfo,
    getCashPrizeAddress,
    getPointflow,
    sureExchange,
    signToday,
    getPointIndex,
    uploadProfile,
    editUserInfo,
    changePhone,
    getMyBorrow,
    cancelBorrowOrder,
    orgList,
    bindingCard,
    messageList,
    isBinding,
    editAddress,
    getMyBookcase,
    deleteAddress,
    deleteBookCase,
    getExpressTrace,
    orderDetail,
    unbunding,
    addAddress,
    setDefAddress,
    returnBorrow,
    renewBorrow,
    addressInfo,
    resetPassword,
    changePassword,
    getmenuItemList,
    addBookshelf,
    specialBookList,
    getOnlinecard,
    beginOnlinecard,
    UpLoadCardfile,
    wxpay,
    payOk,
    getOrderDetail,
    hasEcardOrgList,
    sharePoint,
    confirmSignup,
    tipIndex,
    getEcardFee
}


// WEBPACK FOOTER //
// ./src/service/getData.js